/* eslint-disable jsx-a11y/label-has-for */
/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import SaveCancelPopup from '../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  closeTab,
  handleScrollToEvent,
} from '../../../SharedModules/CommonUtilities/commonUtilities';
import { tabHighLigther } from '../../../SharedModules/utilities/utilities';
import * as constantMessageData from '../../../SharedModules/Errors/constantMessageData';
import {
  dispatchUpdateGeneralParamResultDetails,
  getGeneralSystemParameterDetails,
  handleErrorMessagesUpdateGeneralParam,
  postSaveOrUpdate,
  setUpdateParamGeneralScreen,
} from './store/action';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';

const UpdateParamGeneral = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  // dispatch function
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const errorMessagesFromRedux = useSelector(
    (state) =>
      state?.sharedState?.UpdateParamGeneralReducer?.errorMessagesInRedux
  );
  const updateParamGeneralResultDetail = useSelector(
    (state) =>
      state?.sharedState?.UpdateParamGeneralReducer?.generalSystemParameter
  );
  const updateGeneralParamScreenObj = useSelector(
    (state) =>
      state?.sharedState?.UpdateParamGeneralReducer?.updateGeneralParamObj
  );
  const saveOrUpdateMessage = useSelector((state) => {
    return state.sharedState.UpdateParamGeneralReducer.saveOrUpdateMessage;
  });
  // variable deceleration
  const [open, setOpen] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [successMessages, setSuccessMessage] = React.useState([]);
  const [disabledSaveCancelBtn, setDisabledSaveCancelBtn] =
    React.useState(false);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = React.useState(false);
  const [state, setState] = React.useState(
    updateParamGeneralResultDetail || {}
  );
  // on scroll default top level

  React.useEffect(() => {
    handleScrollToEvent();
    if (!Object.keys(updateGeneralParamScreenObj)?.length > 0) {
      dispatch(getGeneralSystemParameterDetails(''));
    }
  }, []);
  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesFromRedux?.length > 0) {
      tabHighLigther('/updateGeneralParam', true);
    } else {
      tabHighLigther('/updateGeneralParam', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  // set Initial state values
  React.useEffect(() => {
    setState(updateParamGeneralResultDetail);
  }, [updateParamGeneralResultDetail]);
  // handle after call service show success and error message
  // handle close and confirm popup
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs?.filter((x) => {
        return x.navTo === '/updateGeneralParam' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs?.map((item) => {
        if (item.navTo === '/updateGeneralParam' && item.isFormSave) {
          item.isFormSave = false;
          onSubmit(false);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);
  // handing refresh functionality
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateGeneralParamScreenObj &&
      Object.keys(updateGeneralParamScreenObj).length > 0
    ) {
      const newObj = updateTabs?.map((item) => {
        if (item.navTo === '/updateGeneralParam' && !disabledSaveCancelBtn) {
          item.isFormDirty = true;
        } else if (item.navTo === '/updateGeneralParam')
          item.isFormDirty = false;
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [!disabledSaveCancelBtn || updateGeneralParamScreenObj]);
  React.useEffect(() => {
    if (!Object.keys(updateGeneralParamScreenObj)?.length > 0) {
      setDisabledSaveCancelBtn(true);
      dispatch(setUpdateParamGeneralScreen(''));
    } else {
      const tempObj = updateGeneralParamScreenObj;
      setDisabledSaveCancelBtn(tempObj?.disabledSaveCancelBtn);
      if (tempObj?.state) setState(tempObj?.state);
      if (tempObj?.successMessages) setSuccessMessage(tempObj.successMessages);
    }
  }, [updateGeneralParamScreenObj]);
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage.message) {
      setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      setDisabledSaveCancelBtn(true);
      dispatch(getGeneralSystemParameterDetails(''));
      dispatch(
        setUpdateParamGeneralScreen({
          disabledSaveCancelBtn: true,
          successMessages: [constantMessageData.SUCCESSMESSAGE_GENERIC],
        })
      );
      if (!clickOncloseTabBtn) {
        dispatch(setUpdateParamGeneralScreen({}));
        closeTab('/updateGeneralParam', history, dispatch);
      }
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      const newObj1 = updateTabs?.map((item) => {
        if (item.navTo === '/updateGeneralParam') {
          item.isFormSave = false;
          item.isFormDirty = false;
          item.isFormError = false;
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
    } else if (saveOrUpdateMessage === 'failed') {
      const localErr = updateGeneralParamScreenObj?.errorMessages || [];
      localErr.push({
        field: 'APIFailed',
        errorType: 'APIFailed',
        message: constantMessageData.FAILED_MESSAGE_GENERIC,
      });
      dispatch(
        setUpdateParamGeneralScreen({
          ...updateGeneralParamScreenObj,
          disabledSaveCancelBtn: false,
          successMessages: [],
          errorMessages: [...new Set(localErr)],
        })
      );
      handleScrollToEvent();
      setSuccessMessage([]);
      setDisabledSaveCancelBtn(false);
    }
  }, [saveOrUpdateMessage]);
  // call after check all validation
  const onSubmit = (value) => {
    setClickOncloseTabBtn(value);
    setSuccessMessage([]);
    openSave(value);
  };
  // save popup
  const openSave = (value) => {
    if (!value) {
      masterDataSave();
    } else {
      setOpen(value);
      setOpenCancel(false);
    }
  };
  // handing save API calling
  const masterDataSave = () => {
    handelCancelClose();
    setOpen(false);
    const saveRequest = {
      paramTestVO: [],
      updateSysParam: true,
      paramGeneralVO: [{ ...state }],
    };
    if (state && Object.keys(state)?.length > 0) {
      dispatch(postSaveOrUpdate(saveRequest));
    }
    handleScrollToEvent();
  };
  // cancel popup
  const handelCancelClose = () => {
    setOpenCancel(false);
  };
  // save popup
  const handleOpenClose = () => {
    setOpenCancel(true);
  };

  // click on cancel after call
  const handleSaveClose = () => {
    setOpen(false);
  };
  // handing reset All fields & data
  const resetAllFields = () => {
    handelCancelClose();
    dispatch(getGeneralSystemParameterDetails(''));
    setDisabledSaveCancelBtn(true);
    dispatch(setUpdateParamGeneralScreen({}));
    setSuccessMessage([]);
    dispatch(
      handleErrorMessagesUpdateGeneralParam({
        errorMessagesInRedux: [],
      })
    );
    setState({});
    handleScrollToEvent();
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj1 = updateTabs?.map((item) => {
      if (item.navTo === '/updateGeneralParam') {
        item.isFormSave = false;
        item.isFormDirty = false;
        item.isFormError = false;
      }
      return item;
    });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
  };
  // handing On change event on filed level
  const handleOnChangeEvent = (value, name) => {
    setState({ ...state, [name]: value });
    setDisabledSaveCancelBtn(false);
    setSuccessMessage([]);
    dispatch(
      dispatchUpdateGeneralParamResultDetails({
        ...updateParamGeneralResultDetail,
        [name]: value,
      })
    );
    dispatch(
      setUpdateParamGeneralScreen({
        ...updateGeneralParamScreenObj,
        disabledSaveCancelBtn: false,
        successMessages: [],
        state: { ...state, [name]: value },
      })
    );
    dispatch(
      handleErrorMessagesUpdateGeneralParam({
        errorMessagesInRedux: [],
      })
    );
  };
  const checkNumberValidation = (rx, amountVal) => {
    let val = false;
    if (rx.test(amountVal?.toString()?.replace('-', '').trim())) {
      val = true;
    }
    return val;
  };

  return (
    <div className='tabs-container' data-testid='ReqAccReceivable'>
      <div className='tBillPanel custom-check'>
        <div className='paneldevider-line'>
          <SaveCancelPopup
            open={open}
            data-testid='savePopup'
            title='Save'
            onConfim={() => {
              masterDataSave();
            }}
            onCancel={() => {
              handleSaveClose();
            }}
          />
          <SaveCancelPopup
            open={openCancel}
            data-testid='cancelPopup'
            title='Cancel'
            onConfim={() => {
              resetAllFields();
            }}
            onCancel={() => {
              handelCancelClose();
            }}
          />
          <Spinner load={spinnerLoader} />
          <CustomSeparator
            parent1='System'
            parent2='Technical Window'
            parent3='Online Fixes'
            parent4='Update System Parameter'
          />
          <DisplayErrorMessages
            errorMessages={
              errorMessagesFromRedux && errorMessagesFromRedux.length > 0
                ? [...new Set(errorMessagesFromRedux)]
                : []
            }
          />
          <DisplaySuccessMessages successMessages={successMessages} />
          <div className='flex-block justify-end pb-1'>
            <div className='btn-wrapper float-right'>
              <Button
                className='btn btn-success btn-save'
                data-testid='saveBtn'
                disabled={disabledSaveCancelBtn}
                onClick={() => {
                  onSubmit(true);
                }}
              >
                {' '}
                <SVGComponent iconName='Icon-awesome-save' />
                Save
              </Button>

              <Button
                className='btn btn-cancel'
                data-testid='cancelBtn'
                onClick={() => {
                  handleOpenClose();
                }}
                disabled={disabledSaveCancelBtn}
              >
                <SVGComponent iconName='Icon-cancel' />
                Cancel
              </Button>
            </div>
          </div>
          <div className='row'>
            <div className='col-6'>
              <fieldset
                className='custom-fieldset mt-3'
                style={{ height: 'auto' }}
              >
                <legend className='same-font-family'>
                  Rebate Web Upload Options:
                </legend>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>RW Authority: </label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='rwAuthority'
                      id='rwAuthority'
                      data-testid='rwAuthority'
                      inputProps={{
                        maxLength: 60,
                        id: 'rwAuthority',
                        'aria-labelledby': 'rwAuthority',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.rwAuthority}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'rwAuthority')
                      }
                    />
                  </div>
                </div>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>Login ID:</label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='rwUserId'
                      id='rwUserId'
                      data-testid='rwUserId'
                      inputProps={{
                        maxLength: 32,
                        id: 'rwUserId',
                        'aria-labelledby': 'rwUserId',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.rwUserId}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'rwUserId')
                      }
                    />
                  </div>
                </div>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>Password: </label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='rwPassword'
                      id='rwPassword'
                      data-testid='rwPassword'
                      inputProps={{
                        maxLength: 32,
                        id: 'rwPassword',
                        'aria-labelledby': 'rwPassword',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.rwPassword}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'rwPassword')
                      }
                    />
                  </div>
                </div>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>Payer Org:</label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='rwPayerOrg'
                      id='rwPayerOrg'
                      data-testid='rwPayerOrg'
                      inputProps={{
                        maxLength: 32,
                        id: 'rwPayerOrg',
                        'aria-labelledby': 'rwPayerOrg',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.rwPayerOrg}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'rwPayerOrg')
                      }
                    />
                  </div>
                </div>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl frr-display-hidden-checkbox-label'>
                    <label className='param-gen-lbl'>Use Sys JRE Ind: </label>

                    <FormControlLabel
                      control={<Checkbox color='primary' />}
                      id='useSystemJreInd'
                      className='mt-1 ml-1'
                      label='Use Sys'
                      onClick={() => {
                        handleOnChangeEvent(
                          parseInt(state?.useSystemJreInd, [0, 1]) === 1
                            ? 0
                            : 1,
                          'useSystemJreInd'
                        );
                      }}
                      checked={parseInt(state?.useSystemJreInd, [0, 1]) === 1}
                      value={parseInt(state?.useSystemJreInd, [0, 1]) === 1}
                      data-testid='useSystemJreInd'
                    />
                  </div>
                </div>
              </fieldset>
            </div>
            <div className='col-6'>
              <fieldset
                className='custom-fieldset mt-3'
                style={{ height: 'auto' }}
              >
                <legend className='same-font-family'>FTP Options</legend>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>IP Address: </label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='ftpIpAddress'
                      id='ftpIpAddress'
                      data-testid='ftpIpAddress'
                      inputProps={{
                        maxLength: 15,
                        id: 'ftpIpAddress',
                        'aria-labelledby': 'ftpIpAddress',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.ftpIpAddress}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'ftpIpAddress')
                      }
                    />
                  </div>
                </div>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>User ID: </label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='ftpUserId'
                      id='ftpUserId'
                      data-testid='ftpUserId'
                      inputProps={{
                        maxLength: 32,
                        id: 'ftpUserId',
                        'aria-labelledby': 'ftpUserId',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.ftpUserId}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'ftpUserId')
                      }
                    />
                  </div>
                </div>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>Password: </label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='ftpPassword'
                      id='ftpPassword'
                      data-testid='ftpPassword'
                      inputProps={{
                        maxLength: 32,
                        id: 'ftpPassword',
                        'aria-labelledby': 'ftpPassword',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.ftpPassword}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'ftpPassword')
                      }
                    />
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div className='row'>
            <div className='col-6'>
              <fieldset
                className='custom-fieldset mt-3'
                style={{ height: 'auto' }}
              >
                <legend className='same-font-family'>File Load Options:</legend>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>Load User ID: </label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='loadUserId'
                      id='loadUserId'
                      data-testid='loadUserId'
                      inputProps={{
                        maxLength: 32,
                        id: 'loadUserId',
                        'aria-labelledby': 'loadUserId',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.loadUserId}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'loadUserId')
                      }
                    />
                  </div>
                </div>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>Load Password: </label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='loadPassword'
                      id='loadPassword'
                      data-testid='loadPassword'
                      inputProps={{
                        maxLength: 32,
                        id: 'loadPassword',
                        'aria-labelledby': 'loadPassword',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.loadPassword}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'loadPassword')
                      }
                    />
                  </div>
                </div>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>Load IP Address: </label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='loadIpAddress'
                      id='loadIpAddress'
                      data-testid='loadIpAddress'
                      inputProps={{
                        maxLength: 15,
                        id: 'loadIpAddress',
                        'aria-labelledby': 'loadIpAddress',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.loadIpAddress}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'loadIpAddress')
                      }
                    />
                  </div>
                </div>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>Load Port Address: </label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='loadPortAddress'
                      id='loadPortAddress'
                      data-testid='loadPortAddress'
                      inputProps={{
                        maxLength: 15,
                        id: 'loadPortAddress',
                        'aria-labelledby': 'loadPortAddress',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.loadPortAddress}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'loadPortAddress')
                      }
                    />
                  </div>
                </div>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>
                      DB Service Name/SID:{' '}
                    </label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='loadSid'
                      id='loadSid'
                      data-testid='loadSid'
                      inputProps={{
                        maxLength: 128,
                        id: 'loadSid',
                        'aria-labelledby': 'loadSid',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.loadSid}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'loadSid')
                      }
                    />
                  </div>
                </div>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl frr-display-hidden-checkbox-label'>
                    <label className='param-gen-lbl'>
                      Load Audit Indicator:{' '}
                    </label>
                    <FormControlLabel
                      control={<Checkbox color='primary' />}
                      id='loadAuditInd'
                      className='mt-1 ml-1'
                      label='Load Audit'
                      onClick={() => {
                        handleOnChangeEvent(
                          parseInt(state?.loadAuditInd, [0, 1]) === 1 ? 0 : 1,
                          'loadAuditInd'
                        );
                      }}
                      checked={parseInt(state?.loadAuditInd, [0, 1]) === 1}
                      value={parseInt(state?.loadAuditInd, [0, 1]) === 1}
                      data-testid='loadAuditInd'
                    />
                  </div>
                </div>
              </fieldset>
            </div>
            <div className='col-6 exp-col'>
              <fieldset
                className='custom-fieldset mt-3'
                style={{ height: 'auto' }}
              >
                <legend className='same-font-family'>
                  Procedure/Process Table Archive Days
                </legend>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>
                      Procedure Table Archive Days:{' '}
                    </label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='procedureArchTblRetainDays'
                      id='procedureArchTblRetainDays'
                      data-testid='procedureArchTblRetainDays'
                      inputProps={{
                        maxLength: 5,
                        id: 'procedureArchTblRetainDays',
                        'aria-labelledby': 'procedureArchTblRetainDays',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.procedureArchTblRetainDays}
                      onChange={(e) => {
                        if (e.target.value && e.target.value?.includes('.')) {
                          const rx = /^[0-9]{0,3}(\.[0-9]{0,1})?$/;
                          if (checkNumberValidation(rx, e.target.value)) {
                            handleOnChangeEvent(
                              e.target.value,
                              'procedureArchTblRetainDays'
                            );
                          }
                        } else {
                          const rxWithout = /^[0-9]{0,3}?$/;
                          if (
                            checkNumberValidation(rxWithout, e.target.value)
                          ) {
                            handleOnChangeEvent(
                              e.target.value,
                              'procedureArchTblRetainDays'
                            );
                          }
                        }
                      }}
                    />
                  </div>
                </div>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>
                      Procedure Table Retain Days:{' '}
                    </label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='procedureTblRetainDays'
                      id='procedureTblRetainDays'
                      data-testid='procedureTblRetainDays'
                      inputProps={{
                        maxLength: 5,
                        id: 'procedureTblRetainDays',
                        'aria-labelledby': 'procedureTblRetainDays',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.procedureTblRetainDays}
                      onChange={(e) => {
                        if (e.target.value && e.target.value?.includes('.')) {
                          const rx = /^[0-9]{0,3}(\.[0-9]{0,1})?$/;
                          if (checkNumberValidation(rx, e.target.value)) {
                            handleOnChangeEvent(
                              e.target.value,
                              'procedureTblRetainDays'
                            );
                          }
                        } else {
                          const rxWithout = /^[0-9]{0,3}?$/;
                          if (
                            checkNumberValidation(rxWithout, e.target.value)
                          ) {
                            handleOnChangeEvent(
                              e.target.value,
                              'procedureTblRetainDays'
                            );
                          }
                        }
                      }}
                    />
                  </div>
                </div>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>
                      Process Table Archive Days:{' '}
                    </label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='processArchTblRetainDays'
                      id='processArchTblRetainDays'
                      data-testid='processArchTblRetainDays'
                      inputProps={{
                        maxLength: 5,
                        id: 'processArchTblRetainDays',
                        'aria-labelledby': 'processArchTblRetainDays',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.processArchTblRetainDays}
                      onChange={(e) => {
                        if (e.target.value && e.target.value?.includes('.')) {
                          const rx = /^[0-9]{0,3}(\.[0-9]{0,1})?$/;
                          if (checkNumberValidation(rx, e.target.value)) {
                            handleOnChangeEvent(
                              e.target.value,
                              'processArchTblRetainDays'
                            );
                          }
                        } else {
                          const rxWithout = /^[0-9]{0,3}?$/;
                          if (
                            checkNumberValidation(rxWithout, e.target.value)
                          ) {
                            handleOnChangeEvent(
                              e.target.value,
                              'processArchTblRetainDays'
                            );
                          }
                        }
                      }}
                    />
                  </div>
                </div>
                <div className='param-gen-fld'>
                  <div className='mui-custom-form with-select field-xl no-lbl'>
                    <label className='param-gen-lbl'>
                      Process Table Retain Days:{' '}
                    </label>
                    <TextField
                      fullWidth
                      required
                      placeholder=''
                      name='processTblRetainDays'
                      id='processTblRetainDays'
                      data-testid='processTblRetainDays'
                      inputProps={{
                        maxLength: 5,
                        id: 'processTblRetainDays',
                        'aria-labelledby': 'processTblRetainDays',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={state?.processTblRetainDays}
                      onChange={(e) => {
                        if (e.target.value && e.target.value?.includes('.')) {
                          const rx = /^[0-9]{0,3}(\.[0-9]{0,1})?$/;
                          if (checkNumberValidation(rx, e.target.value)) {
                            handleOnChangeEvent(
                              e.target.value,
                              'processTblRetainDays'
                            );
                          }
                        } else {
                          const rxWithout = /^[0-9]{0,3}?$/;
                          if (
                            checkNumberValidation(rxWithout, e.target.value)
                          ) {
                            handleOnChangeEvent(
                              e.target.value,
                              'processTblRetainDays'
                            );
                          }
                        }
                      }}
                    />
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-12 p-0'>
              <div className='param-gen-fld'>
                <div className='mui-custom-form with-select field-xl no-lbl'>
                  <label className='param-gen-lbl-without-legend'>
                    Electronic Allocation File Dir:{' '}
                  </label>
                  <TextField
                    fullWidth
                    required
                    placeholder=''
                    name='electAllocDir'
                    id='electAllocDir'
                    data-testid='electAllocDir'
                    inputProps={{
                      maxLength: 255,
                      id: 'electAllocDir',
                      'aria-labelledby': 'electAllocDir',
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={state?.electAllocDir}
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.value, 'electAllocDir')
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateParamGeneral;
